import WeaLocaleProvider from "../wea-locale-provider";
const { getLabel } = WeaLocaleProvider;

// 橡皮擦
const dotSizeErase = {
  xxs: 16.0,
  xs: 16.0,
  sm: 32.0,
  md: 32.0,
  lg: 48.0,
  xl: 48.0
};

// 笔触
const dotsize = {
  xxs: 2.0,
  xs: 3.0,
  sm: 5.0,
  md: 6.0,
  lg: 9.0,
  xl: 10.0
};

// 手写模式笔触
const dotsizemin = {
  xxs: 1,
  xs: 1.2,
  sm: 1.4,
  md: 1.6,
  lg: 1.8,
  xl: 2
};
// 笔触尺寸
const brushs = ["xxs", "xs", "sm", "md", "lg", "xl"];

// 功能按钮
const getExtraBtns = () => {
  return [
    {
      key: "newLine",
      icon: "icon-coms-huanhang",
      name: getLabel(126869, "换行")
    },
    {
      key: "eraser",
      icon: "icon-coms-xiangpi",
      name: getLabel(513962, "橡皮擦")
    },
    {
      key: "cancel",
      icon: "icon-coms-Revoke2",
      name: getLabel(23757, "撤销")
    },
    {
      key: "clear",
      icon: "icon-coms-delete",
      name: getLabel(500578, "清空")
    }
  ];
};

//字体颜色
const normalColors = [
  "#000",
  "#BA59D1",
  "#2D6ED1",
  "#00A661",
  "#DA4045",
  "#D53265",
  "#DE3A99",
  "#7E56BB",
  "#298AAC",
  "#53C9F6",
  "#68D8B6",
  "#FAC95F",
  "#FF465C",
  "#8269D9",
  "#CAAE01",
  "#FF8012",
  "#F73A53",
  "#C7426F",
  "#DDA2F2",
  "#8D7EE1",
  "#88AFDD",
  "#31CACA",
  "#5AB74B",
  "#FFE15D"
];

export default {
  dotsize,
  dotsizemin,
  brushs,
  extraBtns: getExtraBtns(),
  normalColors,
  dotSizeErase
};



// WEBPACK FOOTER //
// ./ecology9/wea-signature/constant.js